import { combineLatest, distinctUntilChanged, Observable, pipe, UnaryFunction } from 'rxjs';
import { map } from 'rxjs/operators';
import { isEqual } from 'lodash-es';

export const combineLoadingStates = (observables: Observable<boolean>[]) =>
  combineLatest(observables).pipe(map((loadingStates) => loadingStates.some((loading) => loading)));

export const onlyOnChange = <T>() => pipe(distinctUntilChanged(isEqual)) as UnaryFunction<Observable<T>, Observable<T>>;
